/**
 * @fileoverview This demo is used for MarkerClusterer. It will show 100 markers
 * using MarkerClusterer and count the time to show the difference between using
 * MarkerClusterer and without MarkerClusterer.
 * @author Luke Mahe (v2 author: Xiaoxi Wu)
 */

var speedTest = {};

speedTest.pics = null;
speedTest.map = null;
speedTest.markerClusterer = null;
speedTest.markers = [];
speedTest.infoWindow = null;

speedTest.init = function() {
  var latlng = new google.maps.LatLng(40.7814509, -73.9585412);
  var options = {
    'zoom': 4,
    'center': latlng,
    'mapTypeId': google.maps.MapTypeId.ROADMAP
  };
  speedTest.map = new google.maps.Map(document.getElementById('map'), options);      

  speedTest.infoWindow = new google.maps.InfoWindow();

  speedTest.showMarkers();
};

speedTest.showMarkers = function() {
  speedTest.markers = [];

  jQuery('#markerlist').find('a').each(function(index, el) {
    var e = jQuery(el);
    var title =  e.attr('title')
    if(title === ''){
      title = 'No title';
    }
    e.addClass('title');
    var latLng = new google.maps.LatLng(e.data('latitude'),
        e.data('longitude'));
    
    var imageUrl = 'http://chart.apis.google.com/chart?cht=mm&chs=24x32&chco=' +
        'FFFFFF,008CFF,000000&ext=.png';
    var markerImage = new google.maps.MarkerImage(imageUrl,
        new google.maps.Size(24, 32));

    try {
    var marker = new google.maps.Marker({
      'position': latLng,
      'icon': markerImage
    });
    console.log('marker', marker);
  }catch(Error){
    console.log('Error',Error);
  }
   
    var dat = {
      title: e.data('title'),
      content: e.data('content')
    }; 
    var fn = speedTest.markerClickFunction(e, latLng);
    google.maps.event.addListener(marker, 'click', fn);
    google.maps.event.addDomListener(el, 'click', fn);
    speedTest.markers.push(marker);
  });
  speedTest.time();
};

speedTest.markerClickFunction = function(pic, latlng) {
  return function(e) {
    e.cancelBubble = true;
    e.returnValue = false;
    if (e.stopPropagation) {
      e.stopPropagation();
      e.preventDefault();
    }
    var title = pic.attr('title');
    var content = pic.data('content');  

    var infoHtml = '<div class="info"><h3>' + title +
      '</h3><div class="info-body">' +
      content
      +
      '</div>' +
      '</div></div>';

    speedTest.infoWindow.setContent(infoHtml);
    speedTest.infoWindow.setPosition(latlng);
    speedTest.infoWindow.open(speedTest.map);
  };
};

speedTest.clear = function() {  
  for (var i = 0, marker; marker = speedTest.markers[i]; i++) {
    marker.setMap(null);
  }
};

speedTest.change = function() {
  speedTest.clear();
  speedTest.showMarkers();
};

speedTest.time = function() { 
  for (var i = 0, marker; marker = speedTest.markers[i]; i++) {
      console.log(marker);
      marker.setMap(speedTest.map);
    }
};
